import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AutoLoginGuard } from 'angular-auth-oidc-client';
import { AccessdeniedComponent, ApiCredentialsComponent, DynamicformsComponent, ErrorComponent, ExportDataComponent, ForbiddenComponent, HomeComponent, SupportComponent, UnauthorizedComponent } from './components/index';
import { ApiCredentialsActivator, ApiCredentialsDeactivator, ExportDataActivator } from './shared/guards';
import { ApiCredentialsResolverService, ExportDataResolverService } from './shared/resolvers/index';
import { CustomPreloadingService } from './shared/services/index';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    // the child route must be before the wildcard "**" route and after the '' route to work
    path: 'files', data: { preload: false },
    loadChildren: () => import('./modules/files.module').then(m => m.FilesModule),
    canActivate: [AutoLoginGuard]
  },
  { path: 'managedi', data: { preload: false }, loadChildren: () => import('./modules/managedi.module').then(m => m.ManagediModule) },
  { path: 'submissions', data: { preload: false }, loadChildren: () => import('./modules/submissions.module').then(m => m.SubmissionsModule) },
  { path: 'reports', data: { preload: false }, loadChildren: () => import('./modules/reports.module').then(m => m.ReportsModule) },
  { path: 'settings', data: { preload: false }, loadChildren: () => import('./modules/settings.module').then(m => m.SettingsModule) },
  {
    path: 'home',
    component: HomeComponent,
    pathMatch: 'prefix',
    canActivate: [AutoLoginGuard]
  },
  {
    path: 'accessdenied',
    component: AccessdeniedComponent,
    pathMatch: 'prefix',
    canActivate: [AutoLoginGuard]
  },
  { path: 'dynamicformstest', component: DynamicformsComponent, pathMatch: 'prefix', canActivate: [AutoLoginGuard] },
  { path: 'support', component: SupportComponent, pathMatch: 'prefix', canActivate: [AutoLoginGuard] },
  { path: 'unauthorized', component: UnauthorizedComponent, pathMatch: 'prefix' },
  { path: 'forbidden', component: ForbiddenComponent, pathMatch: 'prefix', canActivate: [AutoLoginGuard] },
  { path: '**', component: ErrorComponent },
  { path: 'error', component: ErrorComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      relativeLinkResolution: 'legacy',
      preloadingStrategy: CustomPreloadingService
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }

